import gql from 'graphql-tag';

export default gql`
  query currentCampsite {
    currentCampsite @client {
      id
      name
      lat
      lng
      zoomLevel
      zoomTo
    }
  }
`;
